import { render, staticRenderFns } from "./ForumProductMention.vue?vue&type=template&id=70581516&"
import script from "./ForumProductMention.vue?vue&type=script&lang=js&"
export * from "./ForumProductMention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports